/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-global-search': {
    width: 29,
    height: 24,
    viewBox: '0 0 29 24',
    data: '<path pid="0" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM2 12h20" _stroke="#D5F9D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" _stroke="#D5F9D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="2" d="M19.667 19.333a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333z" _fill="#234357" _stroke="#B5C3CB" stroke-linecap="round" stroke-linejoin="round"/><path pid="3" d="M27 22l-4-4" _stroke="#B5C3CB" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
